<template>
  <div :class="navClass">
    <nav class="navbar is-nav-bar is-fixed-top">
      <div class="navbar-brand">
        <div v-if="isLoggedIn" class="navbar-burger burger" data-target="main-nav" @click="toggleMenu" :class="{'is-active': navIsActive}">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <div id="main-nav" class="navbar-menu" :class="{'is-active': navIsActive}"  v-if="isLoggedIn && !isPasswordChangeNeeded">
        <div class="navbar-start">
         <!-- <div class="navbar-header"><img src="../assets/win-logo.png" class="navbar-image"/></div> -->
        </div>
        <div class="navbar-end">
          <router-link class="navbar-item"  v-if="showLogoutButton" :to="{name: 'home'}">Home</router-link>
          <!-- <span v-if="!navIsActive" class="navbar-item">{{ userInfo.nameFull }}</span> -->
          <template>
            <b-dropdown aria-role="list" class="navbar-item padding-top-4 account-dropdown" v-if="showAccountManagementButton">
              <div slot="trigger" slot-scope="{ active }">
                <span class="vertical-align">Accounts Management</span>
                <b-icon :icon="active ? 'menu-up' : 'menu-down'" class="vertical-align"></b-icon>
              </div>
              <b-dropdown-item aria-role="listitem" @click="navigateToNewPage('adminAccountManagement')">Admin Accounts</b-dropdown-item>
              <b-dropdown-item aria-role="listitem" @click="navigateToNewPage('userAccountManagement')">User Accounts</b-dropdown-item>
              <!-- <b-dropdown-item aria-role="listitem" @click="navigateToNewPage('userAccountManagementForUser')">My User Accounts</b-dropdown-item> -->
            </b-dropdown>
            <router-link class="navbar-item" v-if="showAccountManagementButton" :to="{name:  'accountInformation', params: {userID: userInfo.userID}}">Change Account Information</router-link>
            <router-link class="navbar-item" v-if="showLogoutButton" :to="{ name: 'logout'}">Log out</router-link>
          </template>
        </div>
      </div>
      
    </nav>

  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'NavigationComponent',

  data () {
    return {
      navIsActive: false
    }
  },

  computed:{
    ...mapGetters([
        'isLoggedIn', 'isPasswordChangeNeeded'
      ]),

    ...mapState([
      'userInfo'
    ]),

    onLoginPage: function(){
      return this.$route.name == "login"
    },

    onContentViewer: function(){
      return this.$route.name == "contentViewer"
    },

    slug: function(){
      return this.$route.params.slug
    },

    homePath: function(){
      return "/" + this.slug
    },

    changePasswordPath: function(){
      return "/" + this.slug + "/change-password" + this.userInfo.userID
    },

    navClass: function(){
      if(this.isLoggedIn !=false && this.onLoginPage !=true && this.onContentViewer !=true){
        return "navigation-component"
      }
      else{
        return "navigation-component-no-display"
      }
    },

    showLogoutButton: function(){
      if(this.$route.name == 'changePassword' && this.isPasswordChangeNeeded == false){
        return true
      }
      else if(this.$route.name == 'changeUsernameNeeded'){
        return false
      }
      else if(this.$route.name != 'changePassword' && this.$route.name !='resetPassword'){
        return true
      }
      else if(this.$route.name == 'resetUsername'){
        return false
      }
      else{
        return false
      }
    },

    showChangePasswordButton: function(){
      if(this.$route.name == 'changePassword' && this.isPasswordChangeNeeded == false){
        return true
      }
      else if(this.$route.name == 'changeUsernameNeeded'){
        return false
      }
      else if(this.userInfo.isAdmin == false){
        return false
      }
      else if(this.$route.name != 'changePassword' && this.$route.name !='resetPassword'){
        return true
      }
      else if(this.$route.name == 'resetUsername'){
        return false
      }
      else{
        return false
      }
    },

    showAccountManagementButton: function(){
      if(this.userInfo.isAdmin == false){
        return false
      }
      else if(this.$route.name == 'changeUsernameNeeded'){
        return false
      }
      else if(this.$route.name == 'changePassword' && this.isPasswordChangeNeeded == false){
        return true
      }
      else if(this.$route.name != 'changePassword' && this.$route.name !='resetPassword'){
        return true
      }
      else{
        return false
      }
    }
  },

  methods: {
    /**
     * Toggles Menu
     */
    toggleMenu: function () {
      this.navIsActive = !this.navIsActive
    },


    /**
     * Closes Menu
     */
    closeMenu: function () {
      this.navIsActive = false
    },

    /**
     * Navigates to new page
     */
    navigateToNewPage: function(routerName){
      switch(routerName){
        case "adminAccountManagement":
          this.$router.push({name:  'adminAccountManagement'});
          break
        case "userAccountManagement":
          this.$router.push({name:  'userAccountManagement'});
          break
        case  "userAccountManagementForUser":
          this.$router.push({name:  'userAccountManagementForUser', params:{userID: this.userInfo.userID}});
          break
      }
    }
  }
}
</script>

  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped lang="scss">

  .account-dropdown:hover{
    background-color: #717371;
  }

  .navbar-image {
      max-height: 3rem;
      margin: 0px 8px 0px 8px;
  }
  .navbar-header {
    background-color: #003F60;
  }
  .navbar-menu .is-active {
    background-color: #013652 ;
  }
  .navbar-menu{
    box-shadow: 0 8px 16px rgba(10, 10, 10, .15)
  }
  .navigation-component-no-display{
    display: none;
  }
  .text-white{
    color: #ffffff;
  }
  .navbar-dropdown-item{
    background-color: #7E807E;
  }

  .navbar-dropdown-item{
    background: transparent;
  }

  .is-active{
    background-color: #717371 !important;
  }

  .padding-top-4{
    padding-top: 5px !important;
  }

  .vertical-align{
    vertical-align: middle
  }



  @media only screen and (min-width: 414px) {
    .navbar-menu.is-active {
        display: block;
        padding: 0px;
    }
    .active{
      border-bottom: none ;
      color: #003F60;
    }
  }
  @media only screen and (min-width: 1088px) {
    .active{
      border-bottom: 5px solid #317D9B;
    }
  }


</style>
